/* eslint-disable arrow-parens */
import { useState, useCallback, useEffect, useContext, useRef, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { useDebouncedCallback } from "use-debounce";
import {
	Paper,
	Select,
	MenuItem,
	Grid,
	Button,
	TextField,
	InputAdornment,
	Tooltip,
	IconButton
} from "@material-ui/core";
import { withStyles, Theme } from "@material-ui/core/styles";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../../constants/caption/dashboardHeader";
import { AuthContext, UIContext } from "../../../../../../../contexts";
import GENDERS from "../../../../../../../constants/genders";
import { MARITAL_STATUSES } from "../../../../../../../constants/maritalStatus";
import initCapitalize from "../../../../../../../utils/commonFunctions/initCapitalize";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import "date-fns";
import { DynamicForm } from "../../../../../../../@types/dynamicForm.types";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { MemberTypes } from "../../../../../../../@types/components/member.types";
import useRouteParam from "../../../../../../../hooks/useRouteParam";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../../../utils/api";
import ROLES from "../../../../../../../constants/roles";

import ClearIcon from "@material-ui/icons/Clear";
import SendIcon from "@material-ui/icons/Send";
import EventIcon from "@material-ui/icons/Event";
import InfoIcon from "@material-ui/icons/Info";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import { infoTitleMessage } from "../../../../../../../constants/infoTitleMessage";
import { Validation } from "../../../../../../../@types/validation.types";
import { LazySnackbarAPI } from "../../../../../../shared";
import ExtractRouteParams from "../../../../../../../utils/commonFunctions/extractRouteParams";
import SnackbarAPICall from "../../../../../../shared/snackbar/SnackbarAPICall";
import { SnackbarProps } from "../../../../../../../@types/snackbarAPI.types";

import "../../../../../../../globalStyles/paperFormStyles.css";
import {
	PAY_FREQUENCIES,
	PAY_FREQUENCIES_V2,
	PAY_FREQUENCIES_V3,
	PAY_FREQUENCY
} from "../../../../../../../constants/payFrequency";
import { RATE_TYPE, RATE_TYPES, RATE_TYPE_V2 } from "../../../../../../../constants/rateType";
import { EMPLOYEE_CLASS } from "../../../../../../../constants/employeeClass";
import { PAYCHECK_STATUS } from "../../../../../../../constants/paycheckStatus";
import { Member } from "../../../../../../../@types/member.types";
import { employeeAndAssignedLocationsQueryTypes, Paycheck } from "../../../../../../../@types/paycheck.types";
import prefixCharacterAddition from "../../../../../../../utils/commonFunctions/prefixCharacterAddition";
import { compareInvalidDates } from "../../../../../../../utils/commonFunctions/date";
import ExtractRouteQueryParams from "../../../../../../../utils/commonFunctions/extractRouteQueryParams";
import { GROUP_NUMBER } from "../../../../../../../constants/groups";
import { handleSSNFormat } from "../../../../../../../utils/commonFunctions/SSN";

const date = new Date();
const maxDateRange = date.setDate(date.getDate());

const LightTooltip = withStyles((theme: Theme) => ({
	tooltip: {
		backgroundColor: "#f5f5f9",
		color: "rgba(0, 0, 0, 0.87)",
		boxShadow: theme.shadows[1],
		maxWidth: 130,
		fontSize: 11
	}
}))(Tooltip);

//Rehire API Integration - Left

const AddEmployment = (): JSX.Element => {
	const querySSN = useRouteParam("qs");
	const queryGroupNumber = useRouteParam("gn");
	const [addPaycheckForm, setAddPaycheckForm] = useState<DynamicForm>();
	const [employee, setEmployee] = useState<Member>();
	const [currentPaycheck, setCurrentPaycheck] = useState<Paycheck>();
	const [assignedLocations, setAssignedLocations] = useState<any[]>([]);
	const [paycheckConfig, setPaycheckConfig] = useState<any[]>([]);
	const [employeeClassConfig, setEmployeeClassConfig] = useState<any[]>([]);
	const [buyUpEligibility, setBuyUpEligibility] = useState<boolean>(false);
	const [paycheck, setPaycheck] = useState<any>({
		employment_start_date: "",
		// employment_end_date: "",
		employee_class: "",
		paycheck_start_date: "",
		// paycheck_end_date: "",
		pay_frequency: "",
		rate_type: "",
		hourly_base_pay_rate: null,
		// weekly_base_rate: null,
		// biweekly_base_rate: null,
		base_pay_rate: null,
		// monthly_base_rate: null,
		buy_up_eligibility: false,
		location_number: null
	});
	const [validation, setValidation] = useState<Validation>({
		paycheck: {},
		status: "invalid"
	});
	const _validation = useRef<Validation>();
	const { setDashboardHeader } = useContext(UIContext);
	const [hasAddEmploymentSubmitClick, setHasAddEmploymentSubmitClick] = useState(false);
	const navigate = useNavigate();
	const routeParam = ExtractRouteParams(); // This is to extract the route after ?(Question Mark)
	const routeQueryParam = ExtractRouteQueryParams();
	const [isRehire, setIsRehire] = useState<boolean>(false);
	const [snackbarAPICallProps, setSnackbarAPICallProps] = useState<SnackbarProps>({
		open: false,
		severity: undefined,
		message: "",
		handleSnackbarClose: (event, reason) => {
			if (reason === "clickaway") return;
			setSnackbarAPICallProps(
				Object.assign({}, snackbarAPICallProps, {
					open: false
				})
			);
		}
	});
	const { user } = useContext(AuthContext);
	// const handleValidation = useCallback(async () => {
	// 	const {
	// 		employment_start_date,
	// 		employee_class,
	// 		paycheck_start_date,
	// 		pay_frequency,
	// 		rate_type,
	// 		hourly_base_pay_rate,
	// 		base_pay_rate,
	// 		buy_up_eligibility,
	// 		location_number
	// 	} = paycheck;

	// 	_validation.current = { ...validation, paycheck: {}, status: "invalid" };
	// 	let flag = true;

	// 	const requireField = (field: keyof typeof paycheck, message: string) => {
	// 		_validation.current!.paycheck[field] = message;
	// 		_validation.current!.status = "invalid";
	// 		flag = false;
	// 	};

	// 	// Employment start date validation
	// 	if (!employment_start_date) {
	// 		requireField("employment_start_date", "Employment Start date is required");
	// 	} else {
	// 		if (employee?.hire_date && compareInvalidDates(employee?.hire_date, employment_start_date)) {
	// 			requireField("employment_start_date", "Employment Start Date cannot be less than Hire Date!");
	// 		}
	// 		if (new Date(employment_start_date).getTime() > Date.now()) {
	// 			requireField("employment_start_date", "Employment Start Date cannot be greater than Current Date!");
	// 		}
	// 	}

	// 	// Paycheck start date
	// 	if (!paycheck_start_date) {
	// 		requireField("paycheck_start_date", "Paycheck Start date is required");
	// 	} else {
	// 		if (compareInvalidDates(employment_start_date, paycheck_start_date)) {
	// 			requireField("paycheck_start_date", "Paycheck Start Date cannot be less than Employment Start Date!");
	// 		}
	// 		if (new Date(paycheck_start_date).getTime() > Date.now()) {
	// 			requireField("paycheck_start_date", "Paycheck Start Date cannot be greater than Current Date!");
	// 		}
	// 	}

	// 	if (!pay_frequency) requireField("pay_frequency", "Pay frequency is required");
	// 	if (!rate_type) requireField("rate_type", "Rate type is required");

	// 	// Rates validation
	// 	if (rate_type === RATE_TYPE.hourly_rate && !hourly_base_pay_rate) {
	// 		requireField("hourly_base_pay_rate", "Hourly base pay rate is required");
	// 	}

	// 	if (rate_type === RATE_TYPE.flat_rate && !base_pay_rate) {
	// 		const label =
	// 			{
	// 				[PAY_FREQUENCIES_V3.weekly]: "Weekly",
	// 				[PAY_FREQUENCIES_V3.monthly]: "Monthly",
	// 				[PAY_FREQUENCIES_V3.biweekly]: "Biweekly"
	// 			}[pay_frequency] || "Base";

	// 		requireField("base_pay_rate", `${label} base rate is required`);
	// 	}

	// 	if (!employee_class) {
	// 		requireField("employee_class", "Employee class is required");
	// 	} else if (!isRehire && employee_class === currentPaycheck?.employee_class) {
	// 		requireField("employee_class", "Employee Class cannot be same with Active Employment!");
	// 	}

	// 	if (buy_up_eligibility === null) {
	// 		requireField("buy_up_eligibility", "Buy up eligibility is required");
	// 	}

	// 	if (!location_number) {
	// 		requireField("location_number", "Location is required");
	// 	}

	// 	_validation.current.status = flag ? "valid" : "invalid";
	// 	if (!flag) alert("Please, fill all required fields!");

	// 	setValidation(Object.assign({}, _validation.current));
	// 	return _validation.current.status;
	// }, [currentPaycheck?.employee_class, employee?.hire_date, isRehire, paycheck, validation]);
	const handleValidation = useCallback(async () => {
		const {
			employment_start_date,
			// employment_end_date,
			employee_class,
			paycheck_start_date,
			// paycheck_end_date,
			pay_frequency,
			rate_type,
			hourly_base_pay_rate,
			// weekly_base_rate,
			// monthly_base_rate,
			buy_up_eligibility,
			base_pay_rate,
			location_number
		} = paycheck;
		_validation.current = {
			...validation,
			paycheck: {},
			status: "invalid"
		};
		let flag = true;

		// paycheck validation checking
		if (String(employment_start_date).length === 0) {
			_validation.current.paycheck["employment_start_date"] = "Employment Start date is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (employment_start_date.length !== 0) {
			if (employee?.hire_date !== undefined) {
				if (compareInvalidDates(employee?.hire_date, employment_start_date)) {
					_validation.current.paycheck["employment_start_date"] =
						"Employment Start Date cannot be less than Hire Date!";
					_validation.current["status"] = "invalid";
					flag = false;
				}
			}
		}
		if (employment_start_date.length !== 0) {
			const employmentStartDate = new Date(employment_start_date).getTime();
			const currentDate = new Date().getTime();
			if (employmentStartDate > currentDate) {
				_validation.current.paycheck["employment_start_date"] =
					"Employment Start Date cannot be greater than Current Date!";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		// if (String(employment_end_date).length !== 0) {
		// 	const employmentStartDate = new Date(employment_start_date).getTime();
		// 	const employmentEndDate = new Date(employment_end_date).getTime();
		// 	if (employmentStartDate > employmentEndDate) {
		// 		_validation.current.paycheck["end_date"] = "Employment End date cannot be less than start date";
		// 		_validation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// }
		if (String(paycheck_start_date).length === 0) {
			_validation.current.paycheck["paycheck_start_date"] = "Paycheck Start date is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (paycheck_start_date.length !== 0) {
			if (compareInvalidDates(employment_start_date, paycheck_start_date)) {
				_validation.current.paycheck["paycheck_start_date"] =
					"Paycheck Start Date cannot be less than Employment Start Date!";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		if (paycheck_start_date.length !== 0) {
			const paycheckStartDate = new Date(paycheck_start_date).getTime();
			const currentDate = new Date().getTime();

			if (paycheckStartDate > currentDate) {
				_validation.current.paycheck["paycheck_start_date"] =
					"Paycheck Start Date cannot be greater than Current Date!";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		// if (String(paycheck_end_date).length !== 0) {
		// 	const paycheckStartDate = new Date(paycheck_start_date).getTime();
		// 	const paycheckEndDate = new Date(paycheck_end_date).getTime();
		// 	if (paycheckStartDate > paycheckEndDate) {
		// 		_validation.current.paycheck["paycheck_end_date"] =
		// 			"Paycheck End date cannot be less than Paycheck Start Date";
		// 		_validation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// }
		if (pay_frequency.length === 0) {
			_validation.current.paycheck["pay_frequency"] = "Pay frequency is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (rate_type.length === 0) {
			_validation.current.paycheck["rate_type"] = "Rate type is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (pay_frequency === PAY_FREQUENCIES_V3.weekly) {
			if (rate_type === RATE_TYPE_V2.hourly_rate) {
				// if (queryGroupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES) {
				// } else {
				if (hourly_base_pay_rate === null || hourly_base_pay_rate === 0) {
					_validation.current.paycheck["hourly_base_pay_rate"] = "Hourly base pay rate is required";
					_validation.current["status"] = "invalid";
					flag = false;
				}
				// }
			}
		}
		if (pay_frequency === PAY_FREQUENCIES_V3.monthly) {
			if (rate_type === RATE_TYPE_V2.hourly_rate) {
				// if (queryGroupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES) {
				// } else {
				if (hourly_base_pay_rate === null || hourly_base_pay_rate === 0) {
					_validation.current.paycheck["hourly_base_pay_rate"] = "Hourly base pay rate is required";
					_validation.current["status"] = "invalid";
					flag = false;
				}
				// }
			}
		}
		if (pay_frequency === PAY_FREQUENCIES_V3.weekly) {
			if (rate_type === RATE_TYPE_V2.fixed) {
				// if (queryGroupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES) {
				// } else {
				if (base_pay_rate === null || base_pay_rate === 0) {
					_validation.current.paycheck["base_pay_rate"] = "Weekly base rate is required";
					_validation.current["status"] = "invalid";
					flag = false;
				}
				// }
			}
		}
		if (pay_frequency === PAY_FREQUENCIES_V3.monthly) {
			if (rate_type === RATE_TYPE_V2.fixed) {
				// if (queryGroupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES) {
				// } else {
				if (base_pay_rate === null || base_pay_rate === 0) {
					_validation.current.paycheck["base_pay_rate"] = "Monthly base rate is required";
					_validation.current["status"] = "invalid";
					flag = false;
				}
				// }
			}
		}
		if (pay_frequency === PAY_FREQUENCIES_V3.biweekly) {
			if (rate_type === RATE_TYPE_V2.hourly_rate) {
				// if (queryGroupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES) {
				// } else {
				if (hourly_base_pay_rate === null || hourly_base_pay_rate === 0) {
					_validation.current.paycheck["hourly_base_pay_rate"] = "Hourly base pay rate is required";
					_validation.current["status"] = "invalid";
					flag = false;
				}
				// }
			}
		}
		if (pay_frequency === PAY_FREQUENCIES_V3.biweekly) {
			if (rate_type === RATE_TYPE_V2.fixed) {
				// if (queryGroupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES) {
				// } else {
				if (base_pay_rate === null || base_pay_rate === 0) {
					_validation.current.paycheck["base_pay_rate"] = "Biweekly base rate is required";
					_validation.current["status"] = "invalid";
					flag = false;
				}
				// }
			}
		}
		if (employee_class.length === 0) {
			_validation.current.paycheck["employee_class"] = "Employee class is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (!isRehire) {
			if (employee_class.length !== 0) {
				if (employee_class === currentPaycheck?.employee_class) {
					_validation.current.paycheck["employee_class"] =
						"Employee Class cannot be same with Active Employment!";
					_validation.current["status"] = "invalid";
					flag = false;
				}
			}
		}
		if (buy_up_eligibility === null && buyUpEligibility === true) {
			_validation.current.paycheck["buy_up_eligibility"] = "Buy up eligibility is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (location_number === null) {
			_validation.current.paycheck["location_number"] = "Location is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (flag === true) _validation.current["status"] = "valid";
		else {
			_validation.current["status"] = "invalid";
			alert("Please, fill all required fields!");
		}
		setValidation(Object.assign({}, _validation.current));
		return _validation.current["status"];
	}, [currentPaycheck?.employee_class, employee?.hire_date, isRehire, paycheck, validation]);

	// const handleWeeklyPaycheckChange = useCallback(
	// 	(value: number) => {
	// 		const valueString: string = value.toString();
	// 		const decimalIndex = valueString.indexOf(".") !== -1 ? valueString.indexOf(".") : valueString.indexOf(",");
	// 		if (decimalIndex !== -1 && valueString.length - decimalIndex > 3) {
	// 			return;
	// 		}
	// 		setPaycheck(
	// 			Object.assign({}, paycheck, {
	// 				hourly_base_pay_rate: value * 1,
	// 				// weekly_base_rate: Number((value * 40).toFixed(2)),
	// 				// monthly_base_rate: 0
	// 				base_pay_rate: Number((value * 40).toFixed(2))
	// 			})
	// 		);
	// 	},
	// 	[paycheck]
	// );

	// const handleBiweeklyPaycheckChange = useCallback(
	// 	(value: number) => {
	// 		const valueString: string = value.toString();
	// 		const decimalIndex = valueString.indexOf(".") !== -1 ? valueString.indexOf(".") : valueString.indexOf(",");
	// 		if (decimalIndex !== -1 && valueString.length - decimalIndex > 3) {
	// 			return;
	// 		}
	// 		setPaycheck(
	// 			Object.assign({}, paycheck, {
	// 				hourly_base_pay_rate: value * 1,
	// 				// weekly_base_rate: Number((value * 40).toFixed(2)),
	// 				// monthly_base_rate: 0
	// 				base_pay_rate: Number((value * 90).toFixed(2))
	// 			})
	// 		);
	// 	},
	// 	[paycheck]
	// );

	// const handleMonthlyPaycheckChange = useCallback(
	// 	(value: number) => {
	// 		const valueString: string = value.toString();
	// 		const decimalIndex = valueString.indexOf(".") !== -1 ? valueString.indexOf(".") : valueString.indexOf(",");
	// 		if (decimalIndex !== -1 && valueString.length - decimalIndex > 3) {
	// 			return;
	// 		}
	// 		setPaycheck(
	// 			Object.assign({}, paycheck, {
	// 				hourly_base_pay_rate: value * 1,
	// 				// monthly_base_rate: Number((value * 160).toFixed(2)),
	// 				// weekly_base_rate: 0
	// 				base_pay_rate: Number((value * 160).toFixed(2))
	// 			})
	// 		);
	// 	},
	// 	[paycheck]
	// );

	// const handleWeekHourlyPaycheckChange = useCallback(
	// 	(value: number) => {
	// 		const valueString: string = value.toString();
	// 		const decimalIndex = valueString.indexOf(".") !== -1 ? valueString.indexOf(".") : valueString.indexOf(",");
	// 		if (decimalIndex !== -1 && valueString.length - decimalIndex > 3) {
	// 			return;
	// 		}
	// 		setPaycheck(
	// 			Object.assign({}, paycheck, {
	// 				hourly_base_pay_rate: Number((value / 40).toFixed(2)),
	// 				// weekly_base_rate: value * 1,
	// 				// monthly_base_rate: 0
	// 				base_pay_rate: value * 1
	// 			})
	// 		);
	// 	},
	// 	[paycheck]
	// );

	// const handleBiweekHourlyPaycheckChange = useCallback(
	// 	(value: number) => {
	// 		const valueString: string = value.toString();
	// 		const decimalIndex = valueString.indexOf(".") !== -1 ? valueString.indexOf(".") : valueString.indexOf(",");
	// 		if (decimalIndex !== -1 && valueString.length - decimalIndex > 3) {
	// 			return;
	// 		}
	// 		setPaycheck(
	// 			Object.assign({}, paycheck, {
	// 				hourly_base_pay_rate: Number((value / 90).toFixed(2)),
	// 				// weekly_base_rate: value * 1,
	// 				// monthly_base_rate: 0
	// 				base_pay_rate: value * 1
	// 			})
	// 		);
	// 	},
	// 	[paycheck]
	// );

	// const handleMonthHourlyPaycheckChange = useCallback(
	// 	(value: number) => {
	// 		const valueString: string = value.toString();
	// 		const decimalIndex = valueString.indexOf(".") !== -1 ? valueString.indexOf(".") : valueString.indexOf(",");
	// 		if (decimalIndex !== -1 && valueString.length - decimalIndex > 3) {
	// 			return;
	// 		}
	// 		setPaycheck(
	// 			Object.assign({}, paycheck, {
	// 				hourly_base_pay_rate: Number((value / 160).toFixed(2)),
	// 				// monthly_base_rate: value * 1,
	// 				// weekly_base_rate: 0
	// 				base_pay_rate: value * 1
	// 			})
	// 		);
	// 	},
	// 	[paycheck]
	// );

	// const handlePaycheckChange = useCallback(
	// 	(event: React.ChangeEvent<HTMLInputElement>) => {
	// 		const { name, value } = event.target;
	// 		console.log("Paycheck Change", name, value);

	// 		if (name === "pay_frequency") {
	// 			setPaycheck(
	// 				Object.assign({}, paycheck, {
	// 					pay_frequency: value,
	// 					hourly_base_pay_rate: 0,
	// 					base_pay_rate: 0
	// 					// weekly_base_rate: 0,
	// 					// biweekly_base_rate: 0,
	// 					// monthly_base_rate: 0
	// 				})
	// 			);
	// 		} else if (name === "pay_frequency" && paycheck.rate_type !== "") {
	// 			setPaycheck(
	// 				Object.assign({}, paycheck, {
	// 					hourly_base_pay_rate: 0,
	// 					base_pay_rate: 0
	// 					// weekly_base_rate: 0,
	// 					// biweekly_base_rate: 0,
	// 					// monthly_base_rate: 0
	// 				})
	// 			);
	// 		} else if (name === "rate_type") {
	// 			setPaycheck(
	// 				Object.assign({}, paycheck, {
	// 					rate_type: value,
	// 					hourly_base_pay_rate: 0,
	// 					base_pay_rate: 0
	// 					// weekly_base_rate: 0,
	// 					// biweekly_base_rate: 0,
	// 					// monthly_base_rate: 0
	// 				})
	// 			);
	// 		} else if (
	// 			name === "hourly_base_pay_rate" &&
	// 			paycheck.pay_frequency === PAY_FREQUENCIES_V3.weekly &&
	// 			paycheck.rate_type === RATE_TYPE.hourly_rate
	// 		) {
	// 			if (!isNaN(value as any)) {
	// 				handleWeeklyPaycheckChange(Number(value));
	// 			} else {
	// 				event.target.value = "";
	// 				event.target.value = paycheck.hourly_base_pay_rate
	// 					? (paycheck.hourly_base_pay_rate as unknown as string)
	// 					: "";
	// 			}
	// 		} else if (
	// 			name === "hourly_base_pay_rate" &&
	// 			paycheck.pay_frequency === PAY_FREQUENCIES_V3.biweekly &&
	// 			paycheck.rate_type === RATE_TYPE.hourly_rate
	// 		) {
	// 			if (!isNaN(value as any)) {
	// 				handleBiweeklyPaycheckChange(Number(value));
	// 			} else {
	// 				event.target.value = "";
	// 				event.target.value = paycheck.hourly_base_pay_rate
	// 					? (paycheck.hourly_base_pay_rate as unknown as string)
	// 					: "";
	// 			}
	// 		} else if (
	// 			name === "hourly_base_pay_rate" &&
	// 			paycheck.pay_frequency === PAY_FREQUENCIES_V3.monthly &&
	// 			paycheck.rate_type === RATE_TYPE.hourly_rate
	// 		) {
	// 			if (!isNaN(value as any)) {
	// 				handleMonthlyPaycheckChange(Number(value));
	// 			} else {
	// 				event.target.value = "";
	// 				event.target.value = paycheck.hourly_base_pay_rate
	// 					? (paycheck.hourly_base_pay_rate as unknown as string)
	// 					: "";
	// 			}
	// 		} else if (
	// 			name === "base_pay_rate" &&
	// 			paycheck.pay_frequency === PAY_FREQUENCIES_V3.weekly &&
	// 			paycheck.rate_type === RATE_TYPE.flat_rate
	// 		) {
	// 			if (!isNaN(value as any)) {
	// 				handleWeekHourlyPaycheckChange(Number(value));
	// 			} else {
	// 				event.target.value = "";
	// 				event.target.value = paycheck.weekly_base_rate ? (paycheck.base_pay_rate as unknown as string) : "";
	// 			}
	// 		} else if (
	// 			name === "base_pay_rate" &&
	// 			paycheck.pay_frequency === PAY_FREQUENCIES_V3.monthly &&
	// 			paycheck.rate_type === RATE_TYPE.flat_rate
	// 		) {
	// 			if (!isNaN(value as any)) {
	// 				handleMonthHourlyPaycheckChange(Number(value));
	// 			} else {
	// 				event.target.value = "";
	// 				event.target.value = paycheck.base_pay_rate ? (paycheck.base_pay_rate as unknown as string) : "";
	// 			}
	// 		} else if (
	// 			name === "base_pay_rate" &&
	// 			paycheck.pay_frequency === PAY_FREQUENCIES_V3.biweekly &&
	// 			paycheck.rate_type === RATE_TYPE.flat_rate
	// 		) {
	// 			if (!isNaN(value as any)) {
	// 				handleBiweekHourlyPaycheckChange(Number(value));
	// 			} else {
	// 				event.target.value = "";
	// 				event.target.value = paycheck.base_pay_rate ? (paycheck.base_pay_rate as unknown as string) : "";
	// 			}
	// 		} else if (name === "buy_up_eligibility") {
	// 			if (value === "Yes")
	// 				setPaycheck(
	// 					Object.assign({}, paycheck, {
	// 						buy_up_eligibility: true
	// 					})
	// 				);
	// 			else
	// 				setPaycheck(
	// 					Object.assign({}, paycheck, {
	// 						buy_up_eligibility: false
	// 					})
	// 				);
	// 		} else {
	// 			setPaycheck(Object.assign({}, paycheck, { [name]: value }));
	// 		}
	// 	},
	// 	[
	// 		handleMonthHourlyPaycheckChange,
	// 		handleMonthlyPaycheckChange,
	// 		handleWeekHourlyPaycheckChange,
	// 		handleWeeklyPaycheckChange,
	// 		handleBiweeklyPaycheckChange,
	// 		paycheck
	// 	]
	// );

	// helper function to get multiplier
	const getHourlyMultiplication = (pay_frequency: string) => {
		const config = paycheckConfig.find((hour_mul) => hour_mul.pay_frequency === pay_frequency);
		return config ? config.hourly_multiplication : 1;
	};

	const handlePaycheckChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { name, value } = event.target;

			if (name === "pay_frequency") {
				setPaycheck(
					Object.assign({}, paycheck, {
						pay_frequency: value,
						hourly_base_pay_rate: 0,
						base_pay_rate: 0
					})
				);
				return;
			}

			if (name === "rate_type") {
				setPaycheck(
					Object.assign({}, paycheck, {
						rate_type: value,
						hourly_base_pay_rate: 0,
						base_pay_rate: 0
					})
				);
				return;
			}

			// Handle hourly -> base conversion
			if (name === "hourly_base_pay_rate" && paycheck.rate_type === RATE_TYPE_V2.hourly_rate) {
				if (!isNaN(value as any)) {
					const multiplier = getHourlyMultiplication(paycheck.pay_frequency);
					setPaycheck(
						Object.assign({}, paycheck, {
							hourly_base_pay_rate: Number(value),
							base_pay_rate: Number((Number(value) * multiplier).toFixed(2))
						})
					);
				}
				return;
			}

			// Handle base -> hourly conversion
			if (name === "base_pay_rate" && paycheck.rate_type === RATE_TYPE_V2.fixed) {
				if (!isNaN(value as any)) {
					const multiplier = getHourlyMultiplication(paycheck.pay_frequency);
					setPaycheck(
						Object.assign({}, paycheck, {
							base_pay_rate: Number(value),
							hourly_base_pay_rate: Number((Number(value) / multiplier).toFixed(2))
						})
					);
				}
				return;
			}

			// boolean case
			if (name === "buy_up_eligibility") {
				setPaycheck(
					Object.assign({}, paycheck, {
						buy_up_eligibility: value === "Yes"
					})
				);
				return;
			}
			setPaycheck(Object.assign({}, paycheck, { [name]: value }));
		},
		[paycheck]
	);

	const handlePaycheckDateChange = useCallback(
		(_date: MaterialUiPickersDate, name: string) => {
			const date = new Date(_date as Date);
			const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
			if (name === "employment_start_date") {
				setPaycheck(
					Object.assign({}, paycheck, {
						paycheck_start_date: parsedDate,
						employment_start_date: parsedDate
					})
				);
			} else setPaycheck(Object.assign({}, paycheck, { [name]: parsedDate }));
		},
		[paycheck]
	);

	const handleClearDateField = useCallback(
		(event: any, name: string) => {
			if (name === "employment_start_date") {
				const _paycheck = {
					...paycheck,
					employment_start_date: null,
					paycheck_start_date: null
				};
				setPaycheck(Object.assign({}, _paycheck));
			} else setPaycheck(Object.assign({}, paycheck, { [name]: null }));
		},
		[paycheck]
	);

	// const handleRedirectToMemberDetails = useCallback(() => {
	// 	const pathname = `/employer/member?${routeParam}`;
	// 	navigate(pathname);
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, []);

	const handleRedirectToMemberDetails = useCallback(() => {
		// const pathname = `/employer/member?${routeQueryParam[0]}&${routeQueryParam[2]}`;
		const pathname = `/employer/member?${routeParam}`;

		navigate(pathname);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleAddEmploymentSubmitClick = useCallback(
		async (event: React.MouseEvent<HTMLButtonElement>) => {
			try {
				event.preventDefault();
				const validation = await handleValidation();
				if (validation === "valid") {
					const { employment_start_date, paycheck_start_date } = paycheck;
					const employmentStartDate = new Date(employment_start_date);
					// const employmentEndDate = employment_end_date ? new Date(employment_end_date) : null;
					const paycheckStartDate = new Date(paycheck_start_date);
					// const paycheckEndDate = paycheck_end_date ? new Date(paycheck_end_date) : null;

					const payload: Paycheck = {
						...paycheck,
						member_object_id: employee?._id,
						member_id: employee?.member_id,
						employee_SSN: employee?.SSN,
						group_number: employee?.group_number,
						employment_start_date:
							employmentStartDate.getFullYear() +
							"-" +
							(employmentStartDate.getMonth() + 1) +
							"-" +
							employmentStartDate.getDate(),
						// employment_end_date:
						// 	employmentEndDate !== null
						// 		? employmentEndDate.getFullYear() +
						// 		  "-" +
						// 		  (employmentEndDate.getMonth() + 1) +
						// 		  "-" +
						// 		  employmentEndDate.getDate()
						// 		: employmentEndDate,
						paycheck_start_date:
							paycheckStartDate.getFullYear() +
							"-" +
							(paycheckStartDate.getMonth() + 1) +
							"-" +
							paycheckStartDate.getDate()
						// paycheck_end_date:
						// 	paycheckEndDate !== null
						// 		? paycheckEndDate.getFullYear() +
						// 		  "-" +
						// 		  (paycheckEndDate.getMonth() + 1) +
						// 		  "-" +
						// 		  paycheckEndDate.getDate()
						// 		: paycheckEndDate
					};

					// console.log("PAYLOADREHIRECHECK-->", payload);
					let response: Paycheck;
					if (isRehire) {
						response = await trackPromise(api.member.rehireEmployment(payload));
					} else {
						response = await trackPromise(api.paycheck.addEmployment(payload));
					}

					if (response) {
						setHasAddEmploymentSubmitClick(true);
						// console.log("Response", response);

						setSnackbarAPICallProps(
							Object.assign({}, snackbarAPICallProps, {
								open: true,
								message: "New Employment Submitted Successfully!",
								severity: "success"
							})
						);

						setTimeout(() => {
							handleRedirectToMemberDetails();
						}, 2000);
					}
				} else {
					setHasAddEmploymentSubmitClick(false);
				}
			} catch (error) {
				setHasAddEmploymentSubmitClick(false);
				alert("Add Employment Submission Unsuccessful!");
				throw error;
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[handleValidation]
	);

	const getEmployeeAndAssignedLocations = useCallback(async (_employee_SSN: string, _group_number: number) => {
		const employeeAndAssignedLocationsQuery: employeeAndAssignedLocationsQueryTypes = {
			employee_SSN: _employee_SSN,
			group_number: _group_number
		};

		const response = await trackPromise(
			api.paycheck.getEmployeeAndAssignedLocations(employeeAndAssignedLocationsQuery)
		);
		// console.log("Employee and Assigned Locations: ", response);

		if (response) {
			const { employeeInstance, assignedLocationInstance, paycheckConfigInstanceByGroupNumber } = response;

			setEmployee(Object.assign({}, employeeInstance));
			setAssignedLocations(Object.assign([], assignedLocationInstance));
			setPaycheckConfig(Object.assign([], paycheckConfigInstanceByGroupNumber.paycheck_config));
			setEmployeeClassConfig(Object.assign([], paycheckConfigInstanceByGroupNumber.employee_class));
			setBuyUpEligibility(paycheckConfigInstanceByGroupNumber.buy_up_eligibility);
		}
	}, []);

	const getEmployeeAndPaycheckWithAssignedLocations = useCallback(
		async (_employee_SSN: string, _group_number: number) => {
			const employeeAndAssignedLocationsQuery: employeeAndAssignedLocationsQueryTypes = {
				employee_SSN: _employee_SSN,
				group_number: _group_number
			};

			const response = await trackPromise(
				api.paycheck.getEmployeeAndPaycheckWithAssignedLocations(employeeAndAssignedLocationsQuery)
			);
			// console.log("Employee and Assigned Locations: ", response);

			if (response) {
				const {
					employeeInstance,
					paycheckInstance,
					assignedLocationInstance,
					paycheckConfigInstanceByGroupNumber
				} = response;

				setEmployee(Object.assign({}, employeeInstance));
				setCurrentPaycheck(Object.assign({}, paycheckInstance));
				setAssignedLocations(Object.assign([], assignedLocationInstance));
				setPaycheckConfig(Object.assign([], paycheckConfigInstanceByGroupNumber.paycheck_config));
				setEmployeeClassConfig(Object.assign([], paycheckConfigInstanceByGroupNumber.employee_class));
				setBuyUpEligibility(paycheckConfigInstanceByGroupNumber.buy_up_eligibility);
			}
		},
		[]
	);

	const getRateTypeOptions = (pay_frequency: string) => {
		const found = paycheckConfig.find((item) => item.pay_frequency === pay_frequency);
		return found?.rate_type || [];
	};

	// console.log("Employee dfgdfgdfg", employee);
	// console.log("Current Paycheck", currentPaycheck);
	// console.log("Is Rehire", isRehire);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.add_employment);
	}, [setDashboardHeader]);

	useEffect(() => {
		if (routeParam.includes("rehire")) setIsRehire(true);
		else setIsRehire(false);
	}, [routeParam]);

	useEffect(() => {
		if (querySSN && queryGroupNumber) {
			if (isRehire) getEmployeeAndAssignedLocations(querySSN as string, queryGroupNumber as number);
			else getEmployeeAndPaycheckWithAssignedLocations(querySSN as string, queryGroupNumber as number);
		}
	}, [
		getEmployeeAndAssignedLocations,
		getEmployeeAndPaycheckWithAssignedLocations,
		isRehire,
		queryGroupNumber,
		querySSN
	]);

	useEffect(() => {
		if (paycheck.employment_start_date === null)
			setPaycheck(Object.assign({}, paycheck, { employment_start_date: "" }));

		if (paycheck.paycheck_start_date === null)
			setPaycheck(Object.assign({}, paycheck, { paycheck_start_date: "" }));

		// if (paycheck.paycheck_end_date === null) setPaycheck(Object.assign({}, paycheck, { paycheck_end_date: "" }));
	}, [paycheck]);

	useEffect(() => {
		setAddPaycheckForm(
			Object.assign(
				{},
				{
					"Employee Information": [
						{
							label: "Employee Id",
							name: "member_id",
							onChange: () => null,
							value: employee?.member_id,
							type: "textfield"
						},
						{
							label: "WLT Employee Number",
							name: "employee_number",
							onChange: () => null,
							value: employee?.employee_number,
							type: "textfield"
						},
						{
							label: "First Name",
							name: "first_name",
							value: employee?.first_name,
							onChange: () => null,
							type: "textfield"
						},
						{
							label: "Last Name",
							name: "last_name",
							value: employee?.last_name,

							onChange: () => null,
							type: "textfield"
						},
						{
							label: "SSN / ALt Id",
							name: "SSN",
							onChange: () => null,
							value: employee?.SSN ? handleSSNFormat(user, employee.SSN) : "",
							type: "textfield"
						}
					],
					"Employment Information": [
						{
							label: "Employment Start Date",
							name: "employment_start_date",
							onChange: (date: MaterialUiPickersDate, name: string) =>
								handlePaycheckDateChange(date, name),
							placeholder: "Enter employment start date",
							value: paycheck.employment_start_date,
							type: "date"
						},
						// {
						// 	schema: "paycheck",
						// 	label: "Employment End Date",
						// 	name: "employment_end_date",
						// 	onChange: (date: MaterialUiPickersDate, name: string) =>
						// 		handlePaycheckDateChange(date, name),
						// 	placeholder: "Enter employment end date",
						// 	value: paycheck.employment_end_date,
						// 	type: "date"
						// },
						{
							label: "Employee Class",
							name: "employee_class",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handlePaycheckChange(event),
							placeholder: "Enter employee class",
							value: paycheck.employee_class,
							type: "select",
							// options: EMPLOYEE_CLASS
							options: employeeClassConfig
						}
					],
					"Paycheck Information": [
						{
							label: "Location",
							name: "location_number",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handlePaycheckChange(event),
							// placeholder: "Enter location",
							value: paycheck.location_number,
							type: "select"
							// options: [...assignedLocations]
						},
						{
							label: "Paycheck Start Date",
							name: "paycheck_start_date",
							onChange: () => null,
							placeholder: "Enter paycheck start date",
							value:
								paycheck.paycheck_start_date !== ""
									? prefixCharacterAddition(
											new Date(paycheck?.paycheck_start_date as string).getMonth() + 1
									  ) +
									  "/" +
									  prefixCharacterAddition(
											new Date(paycheck?.paycheck_start_date as string).getDate()
									  ) +
									  "/" +
									  new Date(paycheck?.paycheck_start_date as string).getFullYear()
									: paycheck.paycheck_start_date,

							type: "textfield"
						},
						// {
						// 	label: "Paycheck End Date",
						// 	name: "paycheck_end_date",
						// 	onChange: (date: MaterialUiPickersDate, name: string) =>
						// 		handlePaycheckDateChange(date, name),
						// 	placeholder: "Enter paycheck end date",
						// 	value: paycheck.paycheck_end_date,
						// 	type: "date"
						// },
						{
							label: "Pay Frequency",
							name: "pay_frequency",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handlePaycheckChange(event),
							placeholder: "Enter pay frequency",
							value: paycheck.pay_frequency,
							type: "select",
							// options: queryGroupNumber == 225 ? PAY_FREQUENCIES_V2 : PAY_FREQUENCIES
							options: paycheckConfig.map((item) => item.pay_frequency)
						},
						{
							label: "Rate Type",
							name: "rate_type",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
								if (paycheck.pay_frequency === "") {
									// console.log("Event", event);
									// console.log("Event before", event.target);
									//event.target.name = "";
									event.target.value = "";
									// console.log("Event after", event.target);
									// console.log("Paycheck Event after", paycheck);
									alert("Please select Pay Frequency first!");
									return;
								} else {
									handlePaycheckChange(event);
								}
							},
							placeholder: "Enter rate type",
							value: paycheck.rate_type,
							type: "select",
							// options: RATE_TYPES
							// options: Array.from(new Set(paycheckConfig.flatMap((rate) => rate.rate_type)))
							options: getRateTypeOptions(paycheck.pay_frequency)
						},
						// ...(queryGroupNumber === 225
						// 	? []
						// 	: [
						{
							label: "Hourly Base Pay Rate",
							name: "hourly_base_pay_rate",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handlePaycheckChange(event),
							value: paycheck.hourly_base_pay_rate,
							type: "textfield"
						},
						{
							label: "Base Pay Rate",
							name: "base_pay_rate",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handlePaycheckChange(event),
							value: paycheck.base_pay_rate,
							type: "textfield"
						},
						// {
						// 	label: "Weekly Base Rate",
						// 	name: "weekly_base_rate",
						// 	onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
						// 		handlePaycheckChange(event),
						// 	value: paycheck.weekly_base_rate,
						// 	type: "textfield"
						// },
						// {
						// 	label: "Biweekly Base Rate",
						// 	name: "biweekly_base_rate",
						// 	onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
						// 		handlePaycheckChange(event),
						// 	value: paycheck.biweekly_base_rate,
						// 	type: "textfield"
						// },
						// {
						// 	schema: "paycheck",
						// 	label: "Monthly Base Rate",
						// 	name: "monthly_base_rate",
						// 	onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
						// 		handlePaycheckChange(event),
						// 	value: paycheck.monthly_base_rate,
						// 	type: "textfield"
						// }
						//   ]),
						...(buyUpEligibility
							? [
									{
										schema: "paycheck",
										label: "Buy Up Eligibility",
										name: "buy_up_eligibility",
										onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
											handlePaycheckChange(event),
										placeholder: "Enter buy up eligibility",
										value:
											paycheck.buy_up_eligibility === true
												? "Yes"
												: paycheck.buy_up_eligibility === false
												? "No"
												: "",
										type: "select",
										options: ["Yes", "No"]
									}
							  ]
							: [])
					]
				}
			)
		);
	}, [
		employee,
		paycheck,
		assignedLocations,
		handlePaycheckChange,
		handlePaycheckDateChange,
		paycheckConfig,
		employeeClassConfig,
		buyUpEligibility,
		queryGroupNumber
	]);

	// // console.log("Employee", employee);
	// console.log("Paycheck", paycheck);

	return (
		<div className="edit-profile-information-container">
			<Suspense fallback={<div />}>
				<SnackbarAPICall snackbarProps={snackbarAPICallProps} />
			</Suspense>
			<div className="pf-action-button-container" id="pf-action-button-container">
				<Button
					className="button-green"
					onClick={handleAddEmploymentSubmitClick}
					variant="contained"
					disabled={hasAddEmploymentSubmitClick}
					style={{
						cursor: hasAddEmploymentSubmitClick ? "not-allowed" : "pointer",
						pointerEvents: "unset"
					}}
				>
					<span className="button-label-with-icon">Submit</span>
					<span>
						<SendIcon className="button-icon" />
					</span>
				</Button>
			</div>
			<Grid container spacing={1} className="pf-grid-container">
				{addPaycheckForm &&
					Object.entries(addPaycheckForm).map(([key, value], index) => {
						return (
							<div key={index}>
								<div className="pf-title">{key}</div>
								<Paper className="pf-paper-container" variant="outlined" elevation={3}>
									{value.map((field, index) => {
										const { name, label, value, type, onChange } = field;
										return (
											<Grid item key={index} xl={12} lg={12} md={12} sm={12} xs={12}>
												<Grid
													container
													spacing={1}
													className="pf-label"
													style={{
														display:
															field.name === "base_pay_rate"
																? paycheck.pay_frequency === PAY_FREQUENCIES_V3.weekly
																	? ""
																	: ""
																: field.name === "base_pay_rate"
																? paycheck.pay_frequency === PAY_FREQUENCIES_V3.monthly
																	? ""
																	: ""
																: field.name === "base_pay_rate"
																? paycheck.pay_frequency === PAY_FREQUENCIES_V3.biweekly
																	? ""
																	: ""
																: ""
													}}
													// style={{
													// 	display:
													// 		field.name === "base_pay_rate" &&
													// 		(paycheck.pay_frequency === PAY_FREQUENCIES_V3.weekly ||
													// 			paycheck.pay_frequency === PAY_FREQUENCIES_V3.monthly ||
													// 			paycheck.pay_frequency === PAY_FREQUENCIES_V3.biweekly)
													// 			? ""
													// 			: ""
													// }}
												>
													<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
														<div
															className={
																field.name === "paycheck_end_date"
																	? "pf-label-text"
																	: "pf-label-text required"
															}
															id="pf-label-text"
														>
															{label}
														</div>
													</Grid>
													<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
														{type === "textfield" ? (
															<TextField
																className="input-text-field"
																id={
																	name === "member_id" ||
																	name === "employee_number" ||
																	name === "first_name" ||
																	name === "last_name" ||
																	name === "SSN" ||
																	name === "paycheck_start_date"
																		? "disabled-input-text-field"
																		: "input-text-field"
																}
																type={
																	field.name === "hourly_base_pay_rate" ||
																	field.name === "base_pay_rate"
																		? "number"
																		: "string"
																}
																value={value}
																name={name}
																onChange={onChange}
																variant="outlined"
																disabled={
																	name === "member_id" ||
																	name === "employee_number" ||
																	name === "first_name" ||
																	name === "last_name" ||
																	name === "SSN" ||
																	name === "paycheck_start_date"
																		? true
																		: false
																}
																InputProps={{
																	startAdornment: (
																		<>
																			{name === "hourly_base_pay_rate" ||
																			name === "base_pay_rate" ? (
																				<InputAdornment position="start">
																					<AttachMoneyIcon />
																				</InputAdornment>
																			) : null}
																		</>
																	),
																	endAdornment: (
																		<>
																			{name === "member_id" ||
																			name === "employee_number" ||
																			name === "first_name" ||
																			name === "last_name" ||
																			name === "SSN" ||
																			name === "paycheck_start_date" ? (
																				<InputAdornment position="end">
																					<LightTooltip
																						title={
																							name === "employee_number"
																								? infoTitleMessage.employee_number
																								: name === "SSN"
																								? infoTitleMessage.SSN
																								: name === "member_id"
																								? infoTitleMessage.member_id
																								: name === "first_name"
																								? infoTitleMessage.first_name
																								: name === "last_name"
																								? infoTitleMessage.last_name
																								: name ===
																								  "paycheck_start_date"
																								? infoTitleMessage.employment_paycheck_start_date
																								: ""
																						}
																						placement="right-start"
																						arrow
																					>
																						<InfoIcon
																							style={{
																								color: "#808080",
																								fontSize: "20px",
																								// cursor: !showSaveButton
																								// 	? "default"
																								// 	: "pointer",
																								pointerEvents: "unset"
																							}}
																						/>
																					</LightTooltip>
																				</InputAdornment>
																			) : null}
																		</>
																	),
																	readOnly:
																		name === "member_id" ||
																		name === "employee_number" ||
																		name === "first_name" ||
																		name === "last_name" ||
																		name === "SSN" ||
																		name === "paycheck_start_date" ||
																		(name === "hourly_base_pay_rate" &&
																			paycheck.rate_type !==
																				RATE_TYPE_V2.hourly_rate) ||
																		(name === "base_pay_rate" &&
																			paycheck.rate_type !== RATE_TYPE_V2.fixed)
																			? true
																			: false
																}}
																helperText={validation.paycheck[name]}
																style={{
																	pointerEvents: "unset",
																	width: "340px",
																	borderRadius: 50
																}}
															/>
														) : type === "select" ? (
															<>
																<Select
																	id="text-align-options"
																	name={name}
																	value={value}
																	onChange={onChange}
																	style={{
																		pointerEvents: "unset",
																		minWidth: 180,
																		textAlign: "left",
																		overflowY: "visible"
																	}}
																	MenuProps={{
																		style: { zIndex: 35960 }
																	}}
																	inputProps={{ "aria-label": "Without label" }}
																>
																	<MenuItem value="" disabled>
																		Select Value
																	</MenuItem>
																	{name === "location_number"
																		? assignedLocations.map(
																				(location: any, index: number) => {
																					const {
																						location_name,
																						location_number
																					} = location;
																					return (
																						<MenuItem
																							value={location_number}
																							key={index}
																						>
																							<span className="location-number-menu-item">{`${location_number}`}</span>
																							<span className="location-name-menu-item">{`- ${location_name}`}</span>
																						</MenuItem>
																					);
																				}
																		  )
																		: field?.options?.map((option) => {
																				return (
																					<MenuItem
																						key={option}
																						value={
																							field.name ===
																								"rate_type" &&
																							paycheck.pay_frequency ===
																								""
																								? ""
																								: option
																						}
																					>
																						{name === "employee_class"
																							? option
																							: initCapitalize(
																									option as string
																							  )}
																					</MenuItem>
																				);
																		  })}
																</Select>
																{validation && validation.paycheck[name] ? (
																	<div className="details">
																		<span className="select-validation-text2">
																			{validation.paycheck[name]}
																		</span>
																	</div>
																) : null}
															</>
														) : type === "date" ? (
															<MuiPickersUtilsProvider utils={DateFnsUtils}>
																<KeyboardDatePicker
																	className="from-date-input"
																	id="from-date-input"
																	inputVariant="outlined"
																	label={label}
																	name={name}
																	format="MM/dd/yyyy"
																	error={false}
																	value={value}
																	maxDate={
																		name === "paycheck_start_date" ||
																		name === "employment_start_date"
																			? maxDateRange
																			: undefined
																	}
																	onChange={(date: MaterialUiPickersDate) =>
																		onChange(date, name)
																	}
																	InputProps={{
																		startAdornment: (
																			<IconButton
																				onClick={(event) =>
																					handleClearDateField(event, name)
																				}
																				style={{ order: 1 }}
																			>
																				<ClearIcon
																					color="disabled"
																					fontSize="small"
																				/>
																			</IconButton>
																		),
																		readOnly: true
																	}}
																	InputLabelProps={{
																		shrink: true
																	}}
																	keyboardIcon={
																		<EventIcon
																			style={{
																				color: "#7cb342"
																			}}
																		/>
																	}
																	KeyboardButtonProps={{
																		"aria-label": "change date"
																	}}
																	style={{
																		pointerEvents: "unset",
																		width: "340px",
																		borderRadius: 50
																	}}
																	helperText={validation.paycheck[name]}
																/>
															</MuiPickersUtilsProvider>
														) : null}
													</Grid>
												</Grid>
											</Grid>
										);
									})}
								</Paper>
							</div>
						);
					})}
			</Grid>
			<div className="pf-action-button-container margin-top-action-button" id="pf-action-button-container">
				<Button
					className="button-green"
					onClick={handleAddEmploymentSubmitClick}
					variant="contained"
					disabled={hasAddEmploymentSubmitClick}
					style={{
						cursor: hasAddEmploymentSubmitClick ? "not-allowed" : "pointer",
						pointerEvents: "unset"
					}}
				>
					<span className="button-label-with-icon">Submit</span>
					<span>
						<SendIcon className="button-icon" />
					</span>
				</Button>
			</div>
		</div>
	);
};

export default AddEmployment;
